import { getJson, sendJson } from '@/lib/api';

/** Ideas, feedback and bug reports from the team, filed from the header. */

export const FEEDBACK_KINDS = ['idea', 'feedback', 'bug'] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];
export const FEEDBACK_KIND_LABELS: Readonly<Record<FeedbackKind, string>> = { idea: 'Idea', feedback: 'Feedback', bug: 'Bug' };

export const FEEDBACK_STATUSES = ['new', 'seen', 'done'] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];
export const FEEDBACK_STATUS_LABELS: Readonly<Record<FeedbackStatus, string>> = { new: 'New', seen: 'Seen', done: 'Done' };

export interface Feedback {
  readonly _id: string;
  readonly kind: FeedbackKind;
  readonly title: string;
  readonly details: string;
  readonly page?: string;
  readonly screenshotUrl?: string;
  readonly authorName?: string;
  readonly authorEmail?: string;
  readonly status: FeedbackStatus;
  readonly linearIssueId?: string;
  readonly linearIssueUrl?: string;
  readonly linearError?: string;
  readonly createdAt: string;
}

export interface FeedbackWrite {
  readonly kind: FeedbackKind;
  readonly title: string;
  readonly details: string;
  readonly page?: string;
  readonly screenshotUrl?: string;
}

export async function fileFeedback(body: FeedbackWrite): Promise<{ _id: string }> {
  return sendJson<{ _id: string }>('post', '/feedback', body);
}
export async function listFeedback(signal?: AbortSignal): Promise<readonly Feedback[]> {
  return getJson<Feedback[]>('/feedback', undefined, signal);
}
export async function updateFeedback(id: string, body: { status?: FeedbackStatus; retryLinear?: boolean }): Promise<Feedback> {
  return sendJson<Feedback>('patch', `/feedback/${id}`, body);
}

export function feedbackKindTone(kind: FeedbackKind): 'brand' | 'neutral' | 'danger' {
  return kind === 'bug' ? 'danger' : kind === 'idea' ? 'brand' : 'neutral';
}
export function feedbackStatusTone(status: FeedbackStatus): 'warning' | 'neutral' | 'success' {
  return status === 'new' ? 'warning' : status === 'done' ? 'success' : 'neutral';
}
